import { render } from "./Document.vue?vue&type=template&id=e83ffa94&lang=pug"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"
script.render = render

export default script